import React from 'react';
import Modal from 'jd-library/Modal';
import withPortal from 'jd-library/withPortal';
import Button from './Button/Button';
import FormElement from '../pages/add-edit-product/FormElement';

const AddEditModal = props => {
	return (
		<div className={`prod-block-modal ${props.isUomSliderOpen ? 'uom-slider-open' : ''}`}>
			<Modal
				settings={{
					modalId: 'price-modal',
					variant: 'action',
					class: props.isSearchSliderOpen ? '' :  'price-modal'
				}}
				showOverlay={props.isSearchSliderOpen ? true :  false}
				onHidden={() => props.openCloseAddEditPriceModal(false)}
			>
				<Modal.CloseIcon
					iconClass={'icon-HDRcross'}
				/>

				{props.productUnderEdit && <Modal.Body>
					<div>
						<div className={'add-edit-title'}>
							{props.productUnderEdit.isSellingPrice || props.productUnderEdit?.isSellOnline
								? 'Edit Price'
								: 'Add Price'}
						</div>
						<div className={'product-name'}>
							{props.productUnderEdit.productName}
						</div>
					</div>
				</Modal.Body>}
				{/* <InputWithMovingLabel
					label={props.inputObj.label}
					holderClass={props.inputObj.holderClass}
					input={props.inputObj.input}
					key={props.inputObj.key}
					className='rupee-holder'
				/> */}
				<FormElement
					formElements={props.inputObj}
					errors={props.errors} 
				/>
				<div className={`button-wrapper ${props.productUnderEdit?.isSellOnline?'button-sell-online':''}`}>
					<Button size='lg' clickHandler={props.onPriceUpdate} showLoader={props.showBtnLoader}>
						Update Price
					</Button>
				</div>
			</Modal>
			<div className='overlay-div'></div>
		</div>
	);
};


export default withPortal(AddEditModal, null, 'add-edit-modal');
